<template>
  <applicant-message-reservation-to-applicant
    id="message-reservation-canceled"
    class="boss-message-box-canceled"
    :message-reservation="messageReservation"
    :entry-id="entryId"
    :reservation-status-label="cancelReasonText"
    :use-accordion="true"
    :is-withdraw="isWithdraw"
    @remove="remove"
    @setMessage="setMessage"
  />
</template>

<script>
import * as definition from '@/lib/labelValueMappings'
import ApplicantMessageReservationToApplicant from '@/components/molecules/ApplicantMessageReservationToApplicant'

export default {
  components: {
    ApplicantMessageReservationToApplicant
  },
  props: {
    messageReservation: {
      type: Object,
      required: true
    },
    entryId: {
      type: Number,
      required: true
    },
    isWithdraw: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    entryMessageId () {
      return this.messageReservation.entryMessageId
    },
    cancelReasonText () {
      return definition.entryMessageReservationCancelReason
        .find(item => item.id === this.messageReservation.cancelReasonId)
        .label
    }
  },
  methods: {
    remove () {
      this.$http.secured.delete(`/entry/message/send/entries/${this.entryId}/messages/${this.entryMessageId}/canceled_reservation`).then(() => {
        this.$toasted.global.success({ message: 'メッセージを削除しました' })
        this.$emit('fetchAllMessage')
      })
    },
    setMessage () {
      const { subject, body } = this.messageReservation.message
      this.$emit('setMessage', { message: { subject, body } })
    }
  }
}
</script>
